import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

function Dle() {
  const cellStyle = {
    borderBottomColor: "black",
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
  };
  const cellComplementStyle = {
    borderRightStyle: "solid",
    borderRightColor: "black",
    borderRightWidth: 1,
  };
  return (
    <TableContainer
      sx={{
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 1,
        marginY: 2,
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              <strong>MÓDULO</strong>
            </TableCell>
            <TableCell
              align="center"
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              <strong>HORAS ACADÉMICAS</strong>
            </TableCell>
            <TableCell sx={cellStyle}>
              <strong>DOCENTES</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Gestión de Inventarios y Gerencia de la Demanda
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
              align="center"
            >
              140
            </TableCell>
            <TableCell sx={{ ...cellStyle }}>
              Ing. M.Sc. Carla Lizett Kaune Sarabia
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Logística de Aprovisionamiento
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
              align="center"
            >
              140
            </TableCell>
            <TableCell sx={{ ...cellStyle }}>
              Ing. M.Sc. Yuri Roberto Zamorano Braun
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Logística de Producción
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
              align="center"
            >
              140
            </TableCell>
            <TableCell sx={{ ...cellStyle }}>
              Ing. M. Sc. Oscar Saul Olivares Quintana
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Logística de Distribución
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
              align="center"
            >
              140
            </TableCell>
            <TableCell sx={{ ...cellStyle }}>
              Ing. M.Sc. Mario Ivan Espinoza Garcia
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Logística Internacional
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
              align="center"
            >
              140
            </TableCell>
            <TableCell sx={{ ...cellStyle }}>
              Ing. M.Sc. Carlos Ciro Bilbao la Vieja Pozo
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              Logística Empresarial y Gestión de la Cadena de Suministros
            </TableCell>
            <TableCell
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
              align="center"
            >
              140
            </TableCell>
            <TableCell sx={{ ...cellStyle }}>
              Ing. M.Sc. Gloria Slatka Raznatovic Cruz
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Dle;
